/*eslint-disable*/
module.exports = /*
 * Generated by PEG.js 0.10.0.
 *
 * http://pegjs.org/
 */ (function () {
    'use strict'

    function peg$subclass(child, parent) {
        function ctor() {
            this.constructor = child
        }

        ctor.prototype = parent.prototype
        child.prototype = new ctor()
    }

    function peg$SyntaxError(message, expected, found, location) {
        this.message = message
        this.expected = expected
        this.found = found
        this.location = location
        this.name = 'SyntaxError'

        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, peg$SyntaxError)
        }
    }

    peg$subclass(peg$SyntaxError, Error)

    peg$SyntaxError.buildMessage = function (expected, found) {
        var DESCRIBE_EXPECTATION_FNS = {
            literal: function (expectation) {
                return '"' + literalEscape(expectation.text) + '"'
            },

            class: function (expectation) {
                var escapedParts = '',
                    i

                for (i = 0; i < expectation.parts.length; i++) {
                    escapedParts +=
                        expectation.parts[i] instanceof Array
                            ? classEscape(expectation.parts[i][0]) + '-' + classEscape(expectation.parts[i][1])
                            : classEscape(expectation.parts[i])
                }

                return '[' + (expectation.inverted ? '^' : '') + escapedParts + ']'
            },

            any: function (expectation) {
                return 'any character'
            },

            end: function (expectation) {
                return 'end of boundInput'
            },

            other: function (expectation) {
                return expectation.description
            },
        }

        function hex(ch) {
            return ch.charCodeAt(0).toString(16).toUpperCase()
        }

        function literalEscape(s) {
            return s
                .replace(/\\/g, '\\\\')
                .replace(/"/g, '\\"')
                .replace(/\0/g, '\\0')
                .replace(/\t/g, '\\t')
                .replace(/\n/g, '\\n')
                .replace(/\r/g, '\\r')
                .replace(/[\x00-\x0F]/g, function (ch) {
                    return '\\x0' + hex(ch)
                })
                .replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) {
                    return '\\x' + hex(ch)
                })
        }

        function classEscape(s) {
            return s
                .replace(/\\/g, '\\\\')
                .replace(/\]/g, '\\]')
                .replace(/\^/g, '\\^')
                .replace(/-/g, '\\-')
                .replace(/\0/g, '\\0')
                .replace(/\t/g, '\\t')
                .replace(/\n/g, '\\n')
                .replace(/\r/g, '\\r')
                .replace(/[\x00-\x0F]/g, function (ch) {
                    return '\\x0' + hex(ch)
                })
                .replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) {
                    return '\\x' + hex(ch)
                })
        }

        function describeExpectation(expectation) {
            return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation)
        }

        function describeExpected(expected) {
            var descriptions = new Array(expected.length),
                i,
                j

            for (i = 0; i < expected.length; i++) {
                descriptions[i] = describeExpectation(expected[i])
            }

            descriptions.sort()

            if (descriptions.length > 0) {
                for (i = 1, j = 1; i < descriptions.length; i++) {
                    if (descriptions[i - 1] !== descriptions[i]) {
                        descriptions[j] = descriptions[i]
                        j++
                    }
                }
                descriptions.length = j
            }

            switch (descriptions.length) {
                case 1:
                    return descriptions[0]

                case 2:
                    return descriptions[0] + ' or ' + descriptions[1]

                default:
                    return descriptions.slice(0, -1).join(', ') + ', or ' + descriptions[descriptions.length - 1]
            }
        }

        function describeFound(found) {
            return found ? '"' + literalEscape(found) + '"' : 'end of boundInput'
        }

        return 'Expected ' + describeExpected(expected) + ' but ' + describeFound(found) + ' found.'
    }

    function peg$parse(input, options) {
        options = options !== void 0 ? options : {}

        var peg$FAILED = {},
            peg$startRuleFunctions = { FullSequence: peg$parseFullSequence },
            peg$startRuleFunction = peg$parseFullSequence,
            peg$c0 = function (v) {
                return v
            },
            peg$c1 = function (v) {
                return { type: 'function', name: v, params: [] }
            },
            peg$c2 = function (v, p) {
                return { type: 'function', name: v, params: p }
            },
            peg$c3 = function (v1, v2) {
                return [v1].concat(v2)
            },
            peg$c4 = function (v) {
                return [v]
            },
            peg$c5 = function (id) {
                return { id }
            },
            peg$c6 = function (v) {
                return v
            },
            peg$c7 = function (inner) {
                return { paren: inner, not: true }
            },
            peg$c8 = function (inner) {
                return { paren: inner }
            },
            peg$c9 = function (v1, v2) {
                return { type: 'or', left: v1, right: v2 }
            },
            peg$c10 = function (v1, v2) {
                return [v1].concat(v2)
            },
            peg$c11 = 'OR',
            peg$c12 = peg$literalExpectation('OR', false),
            peg$c13 = 'AND',
            peg$c14 = peg$literalExpectation('AND', false),
            peg$c15 = function (v) {
                return v
            },
            peg$c16 = '(',
            peg$c17 = peg$literalExpectation('(', false),
            peg$c18 = ')',
            peg$c19 = peg$literalExpectation(')', false),
            peg$c20 = ',',
            peg$c21 = peg$literalExpectation(',', false),
            peg$c22 = '{',
            peg$c23 = peg$literalExpectation('{', false),
            peg$c24 = '}',
            peg$c25 = peg$literalExpectation('}', false),
            peg$c26 = function (f) {
                return f
            },
            peg$c27 = function (value) {
                return value
            },
            peg$c28 = ':',
            peg$c29 = peg$literalExpectation(':', false),
            peg$c30 = function (q, n) {
                return { value: n, context: q }
            },
            peg$c31 = function (n) {
                return { value: n }
            },
            peg$c32 = '|',
            peg$c33 = peg$literalExpectation('|', false),
            peg$c34 = function (n, q) {
                return q.concat([n])
            },
            peg$c35 = function (n) {
                return [n]
            },
            peg$c36 = '"',
            peg$c37 = peg$literalExpectation('"', false),
            peg$c38 = function (chars) {
                return chars.join('')
            },
            peg$c39 = "'",
            peg$c40 = peg$literalExpectation("'", false),
            peg$c41 = '\\',
            peg$c42 = peg$literalExpectation('\\', false),
            peg$c43 = peg$anyExpectation(),
            peg$c44 = function (char) {
                return char
            },
            peg$c45 = function (sequence) {
                return sequence
            },
            peg$c46 = /^[^'" ():|,{}]/,
            peg$c47 = peg$classExpectation(["'", '"', ' ', '(', ')', ':', '|', ',', '{', '}'], true, false),
            peg$c48 = function (value) {
                return value.join('')
            },
            peg$c49 = function (s) {
                return s
            },
            peg$c50 = /^[^'" ():|,]/,
            peg$c51 = peg$classExpectation(["'", '"', ' ', '(', ')', ':', '|', ','], true, false),
            peg$c52 = 'NOT',
            peg$c53 = peg$literalExpectation('NOT', false),
            peg$c54 = peg$otherExpectation('whitespace'),
            peg$c55 = /^[ \t\n\r]/,
            peg$c56 = peg$classExpectation([' ', '\t', '\n', '\r'], false, false),
            peg$currPos = 0,
            peg$savedPos = 0,
            peg$posDetailsCache = [{ line: 1, column: 1 }],
            peg$maxFailPos = 0,
            peg$maxFailExpected = [],
            peg$silentFails = 0,
            peg$result

        if ('startRule' in options) {
            if (!(options.startRule in peg$startRuleFunctions)) {
                throw new Error('Can\'t start parsing from rule "' + options.startRule + '".')
            }

            peg$startRuleFunction = peg$startRuleFunctions[options.startRule]
        }

        function text() {
            return input.substring(peg$savedPos, peg$currPos)
        }

        function location() {
            return peg$computeLocation(peg$savedPos, peg$currPos)
        }

        function expected(description, location) {
            location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos)

            throw peg$buildStructuredError(
                [peg$otherExpectation(description)],
                input.substring(peg$savedPos, peg$currPos),
                location
            )
        }

        function error(message, location) {
            location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos)

            throw peg$buildSimpleError(message, location)
        }

        function peg$literalExpectation(text, ignoreCase) {
            return { type: 'literal', text: text, ignoreCase: ignoreCase }
        }

        function peg$classExpectation(parts, inverted, ignoreCase) {
            return {
                type: 'class',
                parts: parts,
                inverted: inverted,
                ignoreCase: ignoreCase,
            }
        }

        function peg$anyExpectation() {
            return { type: 'any' }
        }

        function peg$endExpectation() {
            return { type: 'end' }
        }

        function peg$otherExpectation(description) {
            return { type: 'other', description: description }
        }

        function peg$computePosDetails(pos) {
            var details = peg$posDetailsCache[pos],
                p

            if (details) {
                return details
            } else {
                p = pos - 1
                while (!peg$posDetailsCache[p]) {
                    p--
                }

                details = peg$posDetailsCache[p]
                details = {
                    line: details.line,
                    column: details.column,
                }

                while (p < pos) {
                    if (input.charCodeAt(p) === 10) {
                        details.line++
                        details.column = 1
                    } else {
                        details.column++
                    }

                    p++
                }

                peg$posDetailsCache[pos] = details
                return details
            }
        }

        function peg$computeLocation(startPos, endPos) {
            var startPosDetails = peg$computePosDetails(startPos),
                endPosDetails = peg$computePosDetails(endPos)

            return {
                start: {
                    offset: startPos,
                    line: startPosDetails.line,
                    column: startPosDetails.column,
                },
                end: {
                    offset: endPos,
                    line: endPosDetails.line,
                    column: endPosDetails.column,
                },
            }
        }

        function peg$fail(expected) {
            if (peg$currPos < peg$maxFailPos) {
                return
            }

            if (peg$currPos > peg$maxFailPos) {
                peg$maxFailPos = peg$currPos
                peg$maxFailExpected = []
            }

            peg$maxFailExpected.push(expected)
        }

        function peg$buildSimpleError(message, location) {
            return new peg$SyntaxError(message, null, null, location)
        }

        function peg$buildStructuredError(expected, found, location) {
            return new peg$SyntaxError(peg$SyntaxError.buildMessage(expected, found), expected, found, location)
        }

        function peg$parseFullSequence() {
            var s0, s1, s2

            s0 = peg$currPos
            s1 = []
            s2 = peg$parseexpr()
            if (s2 !== peg$FAILED) {
                while (s2 !== peg$FAILED) {
                    s1.push(s2)
                    s2 = peg$parseexpr()
                }
            } else {
                s1 = peg$FAILED
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parse_()
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0
                    s1 = peg$c0(s1)
                    s0 = s1
                } else {
                    peg$currPos = s0
                    s0 = peg$FAILED
                }
            } else {
                peg$currPos = s0
                s0 = peg$FAILED
            }

            return s0
        }

        function peg$parsefunction() {
            var s0, s1, s2, s3, s4, s5

            s0 = peg$currPos
            s1 = peg$parse_()
            if (s1 !== peg$FAILED) {
                s2 = peg$parseFunctionName()
                if (s2 !== peg$FAILED) {
                    s3 = peg$parseLParen()
                    if (s3 !== peg$FAILED) {
                        s4 = peg$parseRParen()
                        if (s4 !== peg$FAILED) {
                            peg$savedPos = s0
                            s1 = peg$c1(s2)
                            s0 = s1
                        } else {
                            peg$currPos = s0
                            s0 = peg$FAILED
                        }
                    } else {
                        peg$currPos = s0
                        s0 = peg$FAILED
                    }
                } else {
                    peg$currPos = s0
                    s0 = peg$FAILED
                }
            } else {
                peg$currPos = s0
                s0 = peg$FAILED
            }
            if (s0 === peg$FAILED) {
                s0 = peg$currPos
                s1 = peg$parse_()
                if (s1 !== peg$FAILED) {
                    s2 = peg$parseFunctionName()
                    if (s2 !== peg$FAILED) {
                        s3 = peg$parseLParen()
                        if (s3 !== peg$FAILED) {
                            s4 = peg$parseparameters()
                            if (s4 !== peg$FAILED) {
                                s5 = peg$parseRParen()
                                if (s5 !== peg$FAILED) {
                                    peg$savedPos = s0
                                    s1 = peg$c2(s2, s4)
                                    s0 = s1
                                } else {
                                    peg$currPos = s0
                                    s0 = peg$FAILED
                                }
                            } else {
                                peg$currPos = s0
                                s0 = peg$FAILED
                            }
                        } else {
                            peg$currPos = s0
                            s0 = peg$FAILED
                        }
                    } else {
                        peg$currPos = s0
                        s0 = peg$FAILED
                    }
                } else {
                    peg$currPos = s0
                    s0 = peg$FAILED
                }
            }

            return s0
        }

        function peg$parseparameters() {
            var s0, s1, s2, s3

            s0 = peg$currPos
            s1 = peg$parseParam()
            if (s1 !== peg$FAILED) {
                s2 = peg$parseComma()
                if (s2 !== peg$FAILED) {
                    s3 = peg$parseparameters()
                    if (s3 !== peg$FAILED) {
                        peg$savedPos = s0
                        s1 = peg$c3(s1, s3)
                        s0 = s1
                    } else {
                        peg$currPos = s0
                        s0 = peg$FAILED
                    }
                } else {
                    peg$currPos = s0
                    s0 = peg$FAILED
                }
            } else {
                peg$currPos = s0
                s0 = peg$FAILED
            }
            if (s0 === peg$FAILED) {
                s0 = peg$currPos
                s1 = peg$parseParam()
                if (s1 !== peg$FAILED) {
                    peg$savedPos = s0
                    s1 = peg$c4(s1)
                }
                s0 = s1
            }

            return s0
        }

        function peg$parseParam() {
            var s0, s1, s2, s3

            s0 = peg$parseIdentifier()
            if (s0 === peg$FAILED) {
                s0 = peg$currPos
                s1 = peg$parseOpenBrace()
                if (s1 !== peg$FAILED) {
                    s2 = peg$parseIdentifier()
                    if (s2 !== peg$FAILED) {
                        s3 = peg$parseCloseBrace()
                        if (s3 !== peg$FAILED) {
                            peg$savedPos = s0
                            s1 = peg$c5(s2)
                            s0 = s1
                        } else {
                            peg$currPos = s0
                            s0 = peg$FAILED
                        }
                    } else {
                        peg$currPos = s0
                        s0 = peg$FAILED
                    }
                } else {
                    peg$currPos = s0
                    s0 = peg$FAILED
                }
                if (s0 === peg$FAILED) {
                    s0 = peg$currPos
                    s1 = peg$parseOpenBrace()
                    if (s1 !== peg$FAILED) {
                        s2 = peg$parseQualifiedName()
                        if (s2 !== peg$FAILED) {
                            s3 = peg$parseCloseBrace()
                            if (s3 !== peg$FAILED) {
                                peg$savedPos = s0
                                s1 = peg$c5(s2)
                                s0 = s1
                            } else {
                                peg$currPos = s0
                                s0 = peg$FAILED
                            }
                        } else {
                            peg$currPos = s0
                            s0 = peg$FAILED
                        }
                    } else {
                        peg$currPos = s0
                        s0 = peg$FAILED
                    }
                }
            }

            return s0
        }

        function peg$parseexpr() {
            var s0, s1, s2

            s0 = peg$currPos
            s1 = peg$parseSequence()
            if (s1 !== peg$FAILED) {
                s2 = peg$parse_()
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0
                    s1 = peg$c6(s1)
                    s0 = s1
                } else {
                    peg$currPos = s0
                    s0 = peg$FAILED
                }
            } else {
                peg$currPos = s0
                s0 = peg$FAILED
            }

            return s0
        }

        function peg$parseParen() {
            var s0, s1, s2, s3, s4

            s0 = peg$currPos
            s1 = peg$parseNOT()
            if (s1 !== peg$FAILED) {
                s2 = peg$parseLParen()
                if (s2 !== peg$FAILED) {
                    s3 = peg$parseexpr()
                    if (s3 !== peg$FAILED) {
                        s4 = peg$parseRParen()
                        if (s4 !== peg$FAILED) {
                            peg$savedPos = s0
                            s1 = peg$c7(s3)
                            s0 = s1
                        } else {
                            peg$currPos = s0
                            s0 = peg$FAILED
                        }
                    } else {
                        peg$currPos = s0
                        s0 = peg$FAILED
                    }
                } else {
                    peg$currPos = s0
                    s0 = peg$FAILED
                }
            } else {
                peg$currPos = s0
                s0 = peg$FAILED
            }
            if (s0 === peg$FAILED) {
                s0 = peg$currPos
                s1 = peg$parseLParen()
                if (s1 !== peg$FAILED) {
                    s2 = peg$parseexpr()
                    if (s2 !== peg$FAILED) {
                        s3 = peg$parseRParen()
                        if (s3 !== peg$FAILED) {
                            peg$savedPos = s0
                            s1 = peg$c8(s2)
                            s0 = s1
                        } else {
                            peg$currPos = s0
                            s0 = peg$FAILED
                        }
                    } else {
                        peg$currPos = s0
                        s0 = peg$FAILED
                    }
                } else {
                    peg$currPos = s0
                    s0 = peg$FAILED
                }
            }

            return s0
        }

        function peg$parseSequence() {
            var s0, s1, s2, s3

            s0 = peg$currPos
            s1 = []
            s2 = peg$parseValue()
            if (s2 !== peg$FAILED) {
                while (s2 !== peg$FAILED) {
                    s1.push(s2)
                    s2 = peg$parseValue()
                }
            } else {
                s1 = peg$FAILED
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parseOr()
                if (s2 !== peg$FAILED) {
                    s3 = peg$parseSequence()
                    if (s3 !== peg$FAILED) {
                        peg$savedPos = s0
                        s1 = peg$c9(s1, s3)
                        s0 = s1
                    } else {
                        peg$currPos = s0
                        s0 = peg$FAILED
                    }
                } else {
                    peg$currPos = s0
                    s0 = peg$FAILED
                }
            } else {
                peg$currPos = s0
                s0 = peg$FAILED
            }
            if (s0 === peg$FAILED) {
                s0 = peg$currPos
                s1 = peg$parseValue()
                if (s1 !== peg$FAILED) {
                    s2 = peg$parseSequence()
                    if (s2 !== peg$FAILED) {
                        peg$savedPos = s0
                        s1 = peg$c10(s1, s2)
                        s0 = s1
                    } else {
                        peg$currPos = s0
                        s0 = peg$FAILED
                    }
                } else {
                    peg$currPos = s0
                    s0 = peg$FAILED
                }
                if (s0 === peg$FAILED) {
                    s0 = peg$currPos
                    s1 = []
                    s2 = peg$parseParen()
                    if (s2 !== peg$FAILED) {
                        while (s2 !== peg$FAILED) {
                            s1.push(s2)
                            s2 = peg$parseParen()
                        }
                    } else {
                        s1 = peg$FAILED
                    }
                    if (s1 !== peg$FAILED) {
                        s2 = peg$parseOr()
                        if (s2 !== peg$FAILED) {
                            s3 = peg$parseSequence()
                            if (s3 !== peg$FAILED) {
                                peg$savedPos = s0
                                s1 = peg$c9(s1, s3)
                                s0 = s1
                            } else {
                                peg$currPos = s0
                                s0 = peg$FAILED
                            }
                        } else {
                            peg$currPos = s0
                            s0 = peg$FAILED
                        }
                    } else {
                        peg$currPos = s0
                        s0 = peg$FAILED
                    }
                    if (s0 === peg$FAILED) {
                        s0 = peg$currPos
                        s1 = peg$parseParen()
                        if (s1 !== peg$FAILED) {
                            s2 = peg$parseSequence()
                            if (s2 !== peg$FAILED) {
                                peg$savedPos = s0
                                s1 = peg$c10(s1, s2)
                                s0 = s1
                            } else {
                                peg$currPos = s0
                                s0 = peg$FAILED
                            }
                        } else {
                            peg$currPos = s0
                            s0 = peg$FAILED
                        }
                        if (s0 === peg$FAILED) {
                            s0 = peg$parseParen()
                            if (s0 === peg$FAILED) {
                                s0 = peg$parseValue()
                            }
                        }
                    }
                }
            }

            return s0
        }

        function peg$parseOr() {
            var s0, s1, s2

            s0 = peg$currPos
            s1 = peg$parse_()
            if (s1 !== peg$FAILED) {
                if (input.substr(peg$currPos, 2) === peg$c11) {
                    s2 = peg$c11
                    peg$currPos += 2
                } else {
                    s2 = peg$FAILED
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c12)
                    }
                }
                if (s2 !== peg$FAILED) {
                    s1 = [s1, s2]
                    s0 = s1
                } else {
                    peg$currPos = s0
                    s0 = peg$FAILED
                }
            } else {
                peg$currPos = s0
                s0 = peg$FAILED
            }

            return s0
        }

        function peg$parseAnd() {
            var s0, s1, s2

            s0 = peg$currPos
            s1 = peg$parse_()
            if (s1 !== peg$FAILED) {
                if (input.substr(peg$currPos, 3) === peg$c13) {
                    s2 = peg$c13
                    peg$currPos += 3
                } else {
                    s2 = peg$FAILED
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c14)
                    }
                }
                if (s2 !== peg$FAILED) {
                    s1 = [s1, s2]
                    s0 = s1
                } else {
                    peg$currPos = s0
                    s0 = peg$FAILED
                }
            } else {
                peg$currPos = s0
                s0 = peg$FAILED
            }

            return s0
        }

        function peg$parseValues() {
            var s0, s1, s2, s3, s4

            s0 = peg$currPos
            s1 = []
            s2 = peg$currPos
            s3 = peg$parseValue()
            if (s3 !== peg$FAILED) {
                s4 = peg$parse_()
                if (s4 !== peg$FAILED) {
                    peg$savedPos = s2
                    s3 = peg$c6(s3)
                    s2 = s3
                } else {
                    peg$currPos = s2
                    s2 = peg$FAILED
                }
            } else {
                peg$currPos = s2
                s2 = peg$FAILED
            }
            if (s2 !== peg$FAILED) {
                while (s2 !== peg$FAILED) {
                    s1.push(s2)
                    s2 = peg$currPos
                    s3 = peg$parseValue()
                    if (s3 !== peg$FAILED) {
                        s4 = peg$parse_()
                        if (s4 !== peg$FAILED) {
                            peg$savedPos = s2
                            s3 = peg$c6(s3)
                            s2 = s3
                        } else {
                            peg$currPos = s2
                            s2 = peg$FAILED
                        }
                    } else {
                        peg$currPos = s2
                        s2 = peg$FAILED
                    }
                }
            } else {
                s1 = peg$FAILED
            }
            if (s1 !== peg$FAILED) {
                peg$savedPos = s0
                s1 = peg$c15(s1)
            }
            s0 = s1
            if (s0 === peg$FAILED) {
                s0 = peg$parseValue()
            }

            return s0
        }

        function peg$parseLParen() {
            var s0, s1, s2

            s0 = peg$currPos
            s1 = peg$parse_()
            if (s1 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 40) {
                    s2 = peg$c16
                    peg$currPos++
                } else {
                    s2 = peg$FAILED
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c17)
                    }
                }
                if (s2 !== peg$FAILED) {
                    s1 = [s1, s2]
                    s0 = s1
                } else {
                    peg$currPos = s0
                    s0 = peg$FAILED
                }
            } else {
                peg$currPos = s0
                s0 = peg$FAILED
            }

            return s0
        }

        function peg$parseRParen() {
            var s0, s1, s2

            s0 = peg$currPos
            s1 = peg$parse_()
            if (s1 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 41) {
                    s2 = peg$c18
                    peg$currPos++
                } else {
                    s2 = peg$FAILED
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c19)
                    }
                }
                if (s2 !== peg$FAILED) {
                    s1 = [s1, s2]
                    s0 = s1
                } else {
                    peg$currPos = s0
                    s0 = peg$FAILED
                }
            } else {
                peg$currPos = s0
                s0 = peg$FAILED
            }

            return s0
        }

        function peg$parseComma() {
            var s0, s1, s2

            s0 = peg$currPos
            s1 = peg$parse_()
            if (s1 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 44) {
                    s2 = peg$c20
                    peg$currPos++
                } else {
                    s2 = peg$FAILED
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c21)
                    }
                }
                if (s2 !== peg$FAILED) {
                    s1 = [s1, s2]
                    s0 = s1
                } else {
                    peg$currPos = s0
                    s0 = peg$FAILED
                }
            } else {
                peg$currPos = s0
                s0 = peg$FAILED
            }

            return s0
        }

        function peg$parseOpenBrace() {
            var s0, s1, s2

            s0 = peg$currPos
            s1 = peg$parse_()
            if (s1 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 123) {
                    s2 = peg$c22
                    peg$currPos++
                } else {
                    s2 = peg$FAILED
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c23)
                    }
                }
                if (s2 !== peg$FAILED) {
                    s1 = [s1, s2]
                    s0 = s1
                } else {
                    peg$currPos = s0
                    s0 = peg$FAILED
                }
            } else {
                peg$currPos = s0
                s0 = peg$FAILED
            }

            return s0
        }

        function peg$parseCloseBrace() {
            var s0, s1, s2

            s0 = peg$currPos
            s1 = peg$parse_()
            if (s1 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 125) {
                    s2 = peg$c24
                    peg$currPos++
                } else {
                    s2 = peg$FAILED
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c25)
                    }
                }
                if (s2 !== peg$FAILED) {
                    s1 = [s1, s2]
                    s0 = s1
                } else {
                    peg$currPos = s0
                    s0 = peg$FAILED
                }
            } else {
                peg$currPos = s0
                s0 = peg$FAILED
            }

            return s0
        }

        function peg$parseValue() {
            var s0, s1, s2, s3

            s0 = peg$currPos
            s1 = peg$parse_()
            if (s1 !== peg$FAILED) {
                s2 = peg$parsefunction()
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0
                    s1 = peg$c26(s2)
                    s0 = s1
                } else {
                    peg$currPos = s0
                    s0 = peg$FAILED
                }
            } else {
                peg$currPos = s0
                s0 = peg$FAILED
            }
            if (s0 === peg$FAILED) {
                s0 = peg$currPos
                s1 = peg$parse_()
                if (s1 !== peg$FAILED) {
                    s2 = peg$currPos
                    peg$silentFails++
                    if (input.substr(peg$currPos, 2) === peg$c11) {
                        s3 = peg$c11
                        peg$currPos += 2
                    } else {
                        s3 = peg$FAILED
                        if (peg$silentFails === 0) {
                            peg$fail(peg$c12)
                        }
                    }
                    if (s3 === peg$FAILED) {
                        if (input.substr(peg$currPos, 3) === peg$c13) {
                            s3 = peg$c13
                            peg$currPos += 3
                        } else {
                            s3 = peg$FAILED
                            if (peg$silentFails === 0) {
                                peg$fail(peg$c14)
                            }
                        }
                    }
                    peg$silentFails--
                    if (s3 === peg$FAILED) {
                        s2 = void 0
                    } else {
                        peg$currPos = s2
                        s2 = peg$FAILED
                    }
                    if (s2 !== peg$FAILED) {
                        s3 = peg$parseQualifiedName()
                        if (s3 !== peg$FAILED) {
                            peg$savedPos = s0
                            s1 = peg$c27(s3)
                            s0 = s1
                        } else {
                            peg$currPos = s0
                            s0 = peg$FAILED
                        }
                    } else {
                        peg$currPos = s0
                        s0 = peg$FAILED
                    }
                } else {
                    peg$currPos = s0
                    s0 = peg$FAILED
                }
            }

            return s0
        }

        function peg$parseQualifiedName() {
            var s0, s1, s2, s3

            s0 = peg$currPos
            s1 = peg$parseQualifier()
            if (s1 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 58) {
                    s2 = peg$c28
                    peg$currPos++
                } else {
                    s2 = peg$FAILED
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c29)
                    }
                }
                if (s2 !== peg$FAILED) {
                    s3 = peg$parseName()
                    if (s3 !== peg$FAILED) {
                        peg$savedPos = s0
                        s1 = peg$c30(s1, s3)
                        s0 = s1
                    } else {
                        peg$currPos = s0
                        s0 = peg$FAILED
                    }
                } else {
                    peg$currPos = s0
                    s0 = peg$FAILED
                }
            } else {
                peg$currPos = s0
                s0 = peg$FAILED
            }
            if (s0 === peg$FAILED) {
                s0 = peg$currPos
                s1 = peg$parseName()
                if (s1 !== peg$FAILED) {
                    peg$savedPos = s0
                    s1 = peg$c31(s1)
                }
                s0 = s1
            }

            return s0
        }

        function peg$parseQualifier() {
            var s0, s1, s2, s3

            s0 = peg$currPos
            s1 = peg$parseName()
            if (s1 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 124) {
                    s2 = peg$c32
                    peg$currPos++
                } else {
                    s2 = peg$FAILED
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c33)
                    }
                }
                if (s2 !== peg$FAILED) {
                    s3 = peg$parseQualifier()
                    if (s3 !== peg$FAILED) {
                        peg$savedPos = s0
                        s1 = peg$c34(s1, s3)
                        s0 = s1
                    } else {
                        peg$currPos = s0
                        s0 = peg$FAILED
                    }
                } else {
                    peg$currPos = s0
                    s0 = peg$FAILED
                }
            } else {
                peg$currPos = s0
                s0 = peg$FAILED
            }
            if (s0 === peg$FAILED) {
                s0 = peg$currPos
                s1 = peg$parseName()
                if (s1 !== peg$FAILED) {
                    peg$savedPos = s0
                    s1 = peg$c35(s1)
                }
                s0 = s1
            }

            return s0
        }

        function peg$parseString() {
            var s0, s1, s2, s3

            s0 = peg$currPos
            if (input.charCodeAt(peg$currPos) === 34) {
                s1 = peg$c36
                peg$currPos++
            } else {
                s1 = peg$FAILED
                if (peg$silentFails === 0) {
                    peg$fail(peg$c37)
                }
            }
            if (s1 !== peg$FAILED) {
                s2 = []
                s3 = peg$parseDoubleStringCharacter()
                while (s3 !== peg$FAILED) {
                    s2.push(s3)
                    s3 = peg$parseDoubleStringCharacter()
                }
                if (s2 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 34) {
                        s3 = peg$c36
                        peg$currPos++
                    } else {
                        s3 = peg$FAILED
                        if (peg$silentFails === 0) {
                            peg$fail(peg$c37)
                        }
                    }
                    if (s3 !== peg$FAILED) {
                        peg$savedPos = s0
                        s1 = peg$c38(s2)
                        s0 = s1
                    } else {
                        peg$currPos = s0
                        s0 = peg$FAILED
                    }
                } else {
                    peg$currPos = s0
                    s0 = peg$FAILED
                }
            } else {
                peg$currPos = s0
                s0 = peg$FAILED
            }
            if (s0 === peg$FAILED) {
                s0 = peg$currPos
                if (input.charCodeAt(peg$currPos) === 39) {
                    s1 = peg$c39
                    peg$currPos++
                } else {
                    s1 = peg$FAILED
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c40)
                    }
                }
                if (s1 !== peg$FAILED) {
                    s2 = []
                    s3 = peg$parseSingleStringCharacter()
                    while (s3 !== peg$FAILED) {
                        s2.push(s3)
                        s3 = peg$parseSingleStringCharacter()
                    }
                    if (s2 !== peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 39) {
                            s3 = peg$c39
                            peg$currPos++
                        } else {
                            s3 = peg$FAILED
                            if (peg$silentFails === 0) {
                                peg$fail(peg$c40)
                            }
                        }
                        if (s3 !== peg$FAILED) {
                            peg$savedPos = s0
                            s1 = peg$c38(s2)
                            s0 = s1
                        } else {
                            peg$currPos = s0
                            s0 = peg$FAILED
                        }
                    } else {
                        peg$currPos = s0
                        s0 = peg$FAILED
                    }
                } else {
                    peg$currPos = s0
                    s0 = peg$FAILED
                }
            }

            return s0
        }

        function peg$parseDoubleStringCharacter() {
            var s0, s1, s2

            s0 = peg$currPos
            s1 = peg$currPos
            peg$silentFails++
            if (input.charCodeAt(peg$currPos) === 34) {
                s2 = peg$c36
                peg$currPos++
            } else {
                s2 = peg$FAILED
                if (peg$silentFails === 0) {
                    peg$fail(peg$c37)
                }
            }
            if (s2 === peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 92) {
                    s2 = peg$c41
                    peg$currPos++
                } else {
                    s2 = peg$FAILED
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c42)
                    }
                }
            }
            peg$silentFails--
            if (s2 === peg$FAILED) {
                s1 = void 0
            } else {
                peg$currPos = s1
                s1 = peg$FAILED
            }
            if (s1 !== peg$FAILED) {
                if (input.length > peg$currPos) {
                    s2 = input.charAt(peg$currPos)
                    peg$currPos++
                } else {
                    s2 = peg$FAILED
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c43)
                    }
                }
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0
                    s1 = peg$c44(s2)
                    s0 = s1
                } else {
                    peg$currPos = s0
                    s0 = peg$FAILED
                }
            } else {
                peg$currPos = s0
                s0 = peg$FAILED
            }
            if (s0 === peg$FAILED) {
                s0 = peg$currPos
                if (input.charCodeAt(peg$currPos) === 92) {
                    s1 = peg$c41
                    peg$currPos++
                } else {
                    s1 = peg$FAILED
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c42)
                    }
                }
                if (s1 !== peg$FAILED) {
                    s2 = peg$parseEscapeSequence()
                    if (s2 !== peg$FAILED) {
                        peg$savedPos = s0
                        s1 = peg$c45(s2)
                        s0 = s1
                    } else {
                        peg$currPos = s0
                        s0 = peg$FAILED
                    }
                } else {
                    peg$currPos = s0
                    s0 = peg$FAILED
                }
            }

            return s0
        }

        function peg$parseSingleStringCharacter() {
            var s0, s1, s2

            s0 = peg$currPos
            s1 = peg$currPos
            peg$silentFails++
            if (input.charCodeAt(peg$currPos) === 39) {
                s2 = peg$c39
                peg$currPos++
            } else {
                s2 = peg$FAILED
                if (peg$silentFails === 0) {
                    peg$fail(peg$c40)
                }
            }
            if (s2 === peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 92) {
                    s2 = peg$c41
                    peg$currPos++
                } else {
                    s2 = peg$FAILED
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c42)
                    }
                }
            }
            peg$silentFails--
            if (s2 === peg$FAILED) {
                s1 = void 0
            } else {
                peg$currPos = s1
                s1 = peg$FAILED
            }
            if (s1 !== peg$FAILED) {
                if (input.length > peg$currPos) {
                    s2 = input.charAt(peg$currPos)
                    peg$currPos++
                } else {
                    s2 = peg$FAILED
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c43)
                    }
                }
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0
                    s1 = peg$c44(s2)
                    s0 = s1
                } else {
                    peg$currPos = s0
                    s0 = peg$FAILED
                }
            } else {
                peg$currPos = s0
                s0 = peg$FAILED
            }
            if (s0 === peg$FAILED) {
                s0 = peg$currPos
                if (input.charCodeAt(peg$currPos) === 92) {
                    s1 = peg$c41
                    peg$currPos++
                } else {
                    s1 = peg$FAILED
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c42)
                    }
                }
                if (s1 !== peg$FAILED) {
                    s2 = peg$parseEscapeSequence()
                    if (s2 !== peg$FAILED) {
                        peg$savedPos = s0
                        s1 = peg$c45(s2)
                        s0 = s1
                    } else {
                        peg$currPos = s0
                        s0 = peg$FAILED
                    }
                } else {
                    peg$currPos = s0
                    s0 = peg$FAILED
                }
            }

            return s0
        }

        function peg$parseEscapeSequence() {
            var s0

            if (input.charCodeAt(peg$currPos) === 39) {
                s0 = peg$c39
                peg$currPos++
            } else {
                s0 = peg$FAILED
                if (peg$silentFails === 0) {
                    peg$fail(peg$c40)
                }
            }
            if (s0 === peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 34) {
                    s0 = peg$c36
                    peg$currPos++
                } else {
                    s0 = peg$FAILED
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c37)
                    }
                }
                if (s0 === peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 92) {
                        s0 = peg$c41
                        peg$currPos++
                    } else {
                        s0 = peg$FAILED
                        if (peg$silentFails === 0) {
                            peg$fail(peg$c42)
                        }
                    }
                }
            }

            return s0
        }

        function peg$parseIdentifier() {
            var s0, s1, s2, s3

            s0 = peg$currPos
            s1 = peg$parse_()
            if (s1 !== peg$FAILED) {
                s2 = []
                if (peg$c46.test(input.charAt(peg$currPos))) {
                    s3 = input.charAt(peg$currPos)
                    peg$currPos++
                } else {
                    s3 = peg$FAILED
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c47)
                    }
                }
                if (s3 !== peg$FAILED) {
                    while (s3 !== peg$FAILED) {
                        s2.push(s3)
                        if (peg$c46.test(input.charAt(peg$currPos))) {
                            s3 = input.charAt(peg$currPos)
                            peg$currPos++
                        } else {
                            s3 = peg$FAILED
                            if (peg$silentFails === 0) {
                                peg$fail(peg$c47)
                            }
                        }
                    }
                } else {
                    s2 = peg$FAILED
                }
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0
                    s1 = peg$c48(s2)
                    s0 = s1
                } else {
                    peg$currPos = s0
                    s0 = peg$FAILED
                }
            } else {
                peg$currPos = s0
                s0 = peg$FAILED
            }
            if (s0 === peg$FAILED) {
                s0 = peg$currPos
                s1 = peg$parse_()
                if (s1 !== peg$FAILED) {
                    s2 = peg$parseString()
                    if (s2 !== peg$FAILED) {
                        peg$savedPos = s0
                        s1 = peg$c49(s2)
                        s0 = s1
                    } else {
                        peg$currPos = s0
                        s0 = peg$FAILED
                    }
                } else {
                    peg$currPos = s0
                    s0 = peg$FAILED
                }
            }

            return s0
        }

        function peg$parseName() {
            var s0, s1, s2, s3

            s0 = peg$currPos
            s1 = peg$currPos
            peg$silentFails++
            s2 = peg$parseNOT()
            peg$silentFails--
            if (s2 === peg$FAILED) {
                s1 = void 0
            } else {
                peg$currPos = s1
                s1 = peg$FAILED
            }
            if (s1 !== peg$FAILED) {
                s2 = []
                if (peg$c50.test(input.charAt(peg$currPos))) {
                    s3 = input.charAt(peg$currPos)
                    peg$currPos++
                } else {
                    s3 = peg$FAILED
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c51)
                    }
                }
                if (s3 !== peg$FAILED) {
                    while (s3 !== peg$FAILED) {
                        s2.push(s3)
                        if (peg$c50.test(input.charAt(peg$currPos))) {
                            s3 = input.charAt(peg$currPos)
                            peg$currPos++
                        } else {
                            s3 = peg$FAILED
                            if (peg$silentFails === 0) {
                                peg$fail(peg$c51)
                            }
                        }
                    }
                } else {
                    s2 = peg$FAILED
                }
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0
                    s1 = peg$c48(s2)
                    s0 = s1
                } else {
                    peg$currPos = s0
                    s0 = peg$FAILED
                }
            } else {
                peg$currPos = s0
                s0 = peg$FAILED
            }
            if (s0 === peg$FAILED) {
                s0 = peg$parseString()
            }

            return s0
        }

        function peg$parseNOT() {
            var s0, s1, s2

            s0 = peg$currPos
            s1 = peg$parse_()
            if (s1 !== peg$FAILED) {
                if (input.substr(peg$currPos, 3) === peg$c52) {
                    s2 = peg$c52
                    peg$currPos += 3
                } else {
                    s2 = peg$FAILED
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c53)
                    }
                }
                if (s2 !== peg$FAILED) {
                    s1 = [s1, s2]
                    s0 = s1
                } else {
                    peg$currPos = s0
                    s0 = peg$FAILED
                }
            } else {
                peg$currPos = s0
                s0 = peg$FAILED
            }

            return s0
        }

        function peg$parseFunctionName() {
            var s0, s1, s2, s3

            s0 = peg$currPos
            s1 = peg$currPos
            peg$silentFails++
            s2 = peg$parseNOT()
            peg$silentFails--
            if (s2 === peg$FAILED) {
                s1 = void 0
            } else {
                peg$currPos = s1
                s1 = peg$FAILED
            }
            if (s1 !== peg$FAILED) {
                s2 = []
                if (peg$c50.test(input.charAt(peg$currPos))) {
                    s3 = input.charAt(peg$currPos)
                    peg$currPos++
                } else {
                    s3 = peg$FAILED
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c51)
                    }
                }
                if (s3 !== peg$FAILED) {
                    while (s3 !== peg$FAILED) {
                        s2.push(s3)
                        if (peg$c50.test(input.charAt(peg$currPos))) {
                            s3 = input.charAt(peg$currPos)
                            peg$currPos++
                        } else {
                            s3 = peg$FAILED
                            if (peg$silentFails === 0) {
                                peg$fail(peg$c51)
                            }
                        }
                    }
                } else {
                    s2 = peg$FAILED
                }
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0
                    s1 = peg$c48(s2)
                    s0 = s1
                } else {
                    peg$currPos = s0
                    s0 = peg$FAILED
                }
            } else {
                peg$currPos = s0
                s0 = peg$FAILED
            }
            if (s0 === peg$FAILED) {
                s0 = peg$parseString()
            }

            return s0
        }

        function peg$parse_() {
            var s0, s1

            peg$silentFails++
            s0 = []
            if (peg$c55.test(input.charAt(peg$currPos))) {
                s1 = input.charAt(peg$currPos)
                peg$currPos++
            } else {
                s1 = peg$FAILED
                if (peg$silentFails === 0) {
                    peg$fail(peg$c56)
                }
            }
            while (s1 !== peg$FAILED) {
                s0.push(s1)
                if (peg$c55.test(input.charAt(peg$currPos))) {
                    s1 = input.charAt(peg$currPos)
                    peg$currPos++
                } else {
                    s1 = peg$FAILED
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c56)
                    }
                }
            }
            peg$silentFails--
            if (s0 === peg$FAILED) {
                s1 = peg$FAILED
                if (peg$silentFails === 0) {
                    peg$fail(peg$c54)
                }
            }

            return s0
        }

        peg$result = peg$startRuleFunction()

        if (peg$result !== peg$FAILED && peg$currPos === input.length) {
            return peg$result
        } else {
            if (peg$result !== peg$FAILED && peg$currPos < input.length) {
                peg$fail(peg$endExpectation())
            }

            throw peg$buildStructuredError(
                peg$maxFailExpected,
                peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null,
                peg$maxFailPos < input.length
                    ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
                    : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
            )
        }
    }

    return {
        SyntaxError: peg$SyntaxError,
        parse: peg$parse,
    }
})()
